/**
 * brio-extras -- opt-in JS features that sit outside core.
 *
 * Included in a consumer site alongside the core brio bundle. Each
 * feature lives in its own file and is imported here for the
 * "everything in one bundle" path; consumers who'd rather pick a
 * single feature import its standalone file from the prod build's
 * extras/ output directory.
 *
 * Programmatic API mirrors the core: named re-exports for ESM
 * consumers, plus window.brio.{namespace} entries for inline-script
 * use (defensive against load order -- core may not have populated
 * window.brio yet).
 */

import './brio-color-mode.js';
import './brio-dropzone.js';
import './brio-media.js';
import './clamp-text.js';

// --- Re-exports for bundler consumers ---

export { applyTheme, loadTheme } from './brio-color-mode.js';
export { getFiles } from './brio-dropzone.js';
export { BrioClampText } from './clamp-text.js';

// --- Global namespace (non-module contexts) ---
//
// Defensive: extras may load before core, in which case window.brio
// hasn't been initialized yet. Touch the existing object if present;
// otherwise create it. Each extra gets its own namespace.

import { applyTheme, loadTheme } from './brio-color-mode.js';
import { getFiles } from './brio-dropzone.js';
import { BrioClampText } from './clamp-text.js';

window.brio = window.brio || {};
window.brio.colorMode = { applyTheme, loadTheme };
window.brio.dropzone = { getFiles };
window.brio.clampText = { BrioClampText };
